/** reCAPTCHA 校验接口的固定路径。 */
const RECAPTCHA_VERIFY_PATH = '/tools/recaptcha/verify';

/** Axios 异常中与安全日志相关的最小字段。 */
interface AxiosErrorForClientLog {
  config?: {
    method?: string;
    url?: string;
  };
  response?: {
    status?: number;
  };
}

/**
 * 返回可写入客户端日志的 Axios 异常字符串。
 * reCAPTCHA 请求仅保留固定摘要，其他接口延续原有序列化行为。
 */
export function serializeAxiosErrorForClientLog(error: unknown): string | undefined {
  const axiosError = error as AxiosErrorForClientLog;
  const rawUrl = axiosError?.config?.url;
  const requestPath = rawUrl?.split('?')[0];

  if (requestPath?.endsWith(RECAPTCHA_VERIFY_PATH)) {
    return JSON.stringify({
      event: 'recaptcha_verify_request_failed',
      method: axiosError.config?.method?.toUpperCase(),
      path: RECAPTCHA_VERIFY_PATH,
      status: axiosError.response?.status,
    });
  }

  return JSON.stringify(error);
}
